import React from "react";
import { Box, Typography } from "@mui/material";
import { MobileCard } from "@ui/components/card";
import { SIconButton } from "@ui/components/buttons/SIconButton";
import { SButton } from "@ui/components/buttons/SButton";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";
export const AlarmCauseCard = ({ row, onDelete, onEdit, }) => {
    const { t } = useTranslation(["common"]);
    return (React.createElement(MobileCard, null,
        React.createElement(Typography, { variant: "subtitle2" }, row.definition),
        React.createElement(Box, { sx: { display: "flex", alignItems: "center", gap: 1 } },
            React.createElement(SIconButton, { colorVariant: "error", title: "Delete", size: "small", onClick: () => onDelete(row.id) },
                React.createElement(Icon, { icon: "mingcute:close-line" })),
            React.createElement(SButton, { variant: "soft", color: "primary", size: "medium", fullWidth: true, onClick: () => onEdit(row.id) }, t("common:actions.edit")))));
};
